"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
var _api = _interopRequireDefault(require("./api"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DeckStore = /*#__PURE__*/function (_RootStore) {
  function DeckStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, DeckStore);
    _this = _callSuper(this, DeckStore);
    _this.config = {
      model: _models.Deck,
      deserialize: true,
      GET: {
        index: '/decks',
        show: '/decks/:deckId'
      },
      PUT: {
        update: '/decks/:deckId',
        autoCreateExercises: '/decks/:deckId/auto_create_exercises',
        createCache: '/decks/:deckId/create_cache',
        clearExercises: '/decks/:deckId/clear_exercises',
        createWords: '/decks/:deckId/create_words',
        cardsCount: '/decks/:deckId/cards_count',
        pastDueCount: '/decks/:deckId/past_due_count',
        deleteReviewCards: '/decks/:deckId/delete_review_cards',
        resetReviewCards: '/decks/:deckId/reset_review_cards',
        updateReviewAfter: '/decks/:deckId/update_review_after',
        addAllToReviews: '/decks/:deckId/add_all_to_reviews',
        clearAllFromReviews: '/decks/:deckId/clear_all_from_reviews',
        updateLanguagesString: '/decks/:deckId/update_languages_string',
        updateValidSetup: '/decks/:deckId/update_valid_setup',
        treeNodeDecksWithSameWords: '/decks/:deckId/get_tree_node_decks_with_same_words',
        createConjugationSentences: '/decks/:deckId/create_conjugation_sentences'
      },
      POST: {
        mobileReviewRequest: '/decks/:deckId/mobile_review_request',
        create: '/decks',
        deleteAllReviewCards: '/decks/delete_all_review_cards',
        createFromSentences: '/decks/create_from_sentences'
      },
      DELETE: {
        destroy: '/decks/:deckId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(DeckStore, _RootStore);
  return (0, _createClass2["default"])(DeckStore, [{
    key: "mobileReviewRequest",
    value: function mobileReviewRequest(params, callback) {
      return _api["default"].ajax({
        method: 'POST',
        url: new _models.UrlBuilder(this.config).buildFromUrls('POST', 'mobileReviewRequest', params.ids),
        queryStrings: params.queryStrings,
        data: {},
        successCallback: callback,
        failureCallback: params.failureCallback,
        onRequestError: params.onRequestError
      });
    }
  }, {
    key: "createConjugationSentences",
    value: function createConjugationSentences(params, callback) {
      this.api(params, callback, 'PUT', 'createConjugationSentences');
    }
  }, {
    key: "getTreeNodeDecksWithSameWords",
    value: function getTreeNodeDecksWithSameWords(params, callback) {
      this.api(params, callback, 'PUT', 'treeNodeDecksWithSameWords');
    }
  }, {
    key: "deleteReviewCards",
    value: function deleteReviewCards(params, callback) {
      this.api(params, callback, 'PUT', 'deleteReviewCards');
    }
  }, {
    key: "updateValidSetup",
    value: function updateValidSetup(params, callback) {
      this.api(params, callback, 'PUT', 'updateValidSetup');
    }
  }, {
    key: "deleteAllReviewCards",
    value: function deleteAllReviewCards(params, callback) {
      this.api(params, callback, 'POST', 'deleteAllReviewCards');
    }
  }, {
    key: "createFromSentences",
    value: function createFromSentences(params, callback) {
      this.api(params, callback, 'POST', 'createFromSentences');
    }
  }, {
    key: "resetReviewCards",
    value: function resetReviewCards(params, callback) {
      this.api(params, callback, 'PUT', 'resetReviewCards');
    }
  }, {
    key: "autoCreateExercises",
    value: function autoCreateExercises(params, callback) {
      this.api(params, callback, 'PUT', 'autoCreateExercises');
    }
  }, {
    key: "addAllToReviews",
    value: function addAllToReviews(params, callback) {
      this.api(params, callback, 'PUT', 'addAllToReviews');
    }
  }, {
    key: "updateLanguagesString",
    value: function updateLanguagesString(params, callback) {
      this.api(params, callback, 'PUT', 'updateLanguagesString');
    }
  }, {
    key: "clearAllFromReviews",
    value: function clearAllFromReviews(params, callback) {
      this.api(params, callback, 'PUT', 'clearAllFromReviews');
    }
  }, {
    key: "downloadToMobile",
    value: function downloadToMobile(params, callback) {
      this.api(params, callback, 'PUT', 'downloadToMobile');
    }
  }, {
    key: "clearExercises",
    value: function clearExercises(params, callback) {
      this.api(params, callback, 'PUT', 'clearExercises');
    }
  }, {
    key: "createWords",
    value: function createWords(params, callback) {
      this.api(params, callback, 'PUT', 'createWords');
    }
  }, {
    key: "cardsCount",
    value: function cardsCount(params, callback) {
      this.api(params, callback, 'PUT', 'cardsCount');
    }
  }, {
    key: "pastDueCount",
    value: function pastDueCount(params, callback) {
      this.api(params, callback, 'PUT', 'pastDueCount');
    }
  }, {
    key: "updateReviewAfter",
    value: function updateReviewAfter(params, callback) {
      this.api(params, callback, 'PUT', 'updateReviewAfter');
    }
  }, {
    key: "getFilteredIndex",
    value: function getFilteredIndex() {
      this.getIndex({
        sort: 'finished, -updated_at',
        filters: {
          deck_type: '!review'
        }
      });
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new DeckStore();